export default {
  peopleLabelColor: Styles.color.black,
  cartPreviewItemPColor: Styles.color.black,
};
